import beFlagImg from 'assets/svg/Belgium.svg';
import frFlagImg from 'assets/svg/France.svg';
import deFlagImg from 'assets/svg/Germany.svg';
import nlFlagImg from 'assets/svg/Netherlands.svg';
import ukFlagImg from 'assets/svg/UnitedKingdom.svg';
import type { ComponentProps, FC } from 'react';

const flagsMap = {
  de: deFlagImg,
  fr: frFlagImg,
  nl: nlFlagImg,
  be: beFlagImg,
  en: ukFlagImg,
  default: beFlagImg,
};

type CountryFlagRounded = {
  country: 'be' | 'de' | 'nl' | 'fr' | 'en';
} & ComponentProps<'img'>;

const CountryFlagRounded: FC<CountryFlagRounded> = ({ country, ...rest }) => (
  <img src={flagsMap[country] || flagsMap.default} height="21px" {...rest} />
);

export default CountryFlagRounded;
